import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Plus, Pencil, Trash2, Copy } from "lucide-react";
import { courseApi } from "./adminApi";
import "./Admin.css";
export default function ManageCourses() {
  const navigate = useNavigate();
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [deletingId, setDeletingId] = useState(null);
  const [duplicatingId, setDuplicatingId] = useState(null);
  async function load() {
    setLoading(true);
    setError("");
    try {
      const data = await courseApi.listAll();
      setCourses(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    load();
  }, []);
  async function handleDelete(course) {
    if (!window.confirm(`Delete the course "${course.name}"? This can't be undone.`)) return;
    setDeletingId(course._id);
    try {
      await courseApi.remove(course._id);
      setCourses((prev) => prev.filter((c) => c._id !== course._id));
    } catch (err) {
      alert(err.message);
    } finally {
      setDeletingId(null);
    }
  }
  async function handleDuplicate(course) {
    setDuplicatingId(course._id);
    try {
      const clone = await courseApi.duplicate(course._id);
      navigate(`/admin/courses/${clone._id}/edit`);
    } catch (err) {
      alert(err.message);
    } finally {
      setDuplicatingId(null);
    }
  }
  return (
    <div>
      <div className="admin-topbar">
        <h1>Courses</h1>
        <Link to="/admin/courses/new" className="admin-btn admin-btn--primary" style={{ width: "auto" }}>
          <Plus size={16} /> Add Course
        </Link>
      </div>
      {error && <div className="admin-error">{error}</div>}
      {loading ? (
        <p>Loading…</p>
      ) : courses.length === 0 ? (
        <div className="admin-table-wrap">
          <div className="admin-empty">No courses yet. Click "Add Course" to create your first one.</div>
        </div>
      ) : (
        <div className="admin-table-wrap">
          <table className="admin-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Slug</th>
                <th>Category</th>
                <th>Status</th>
                <th>Order</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {courses.map((course) => (
                <tr key={course._id}>
                  <td>{course.name}</td>
                  <td style={{ color: "var(--c-mut)" }}>{course.slug}</td>
                  <td>{course.category || "—"}</td>
                  <td>
                    <span className={`admin-badge admin-badge--${course.isPublished ? "published" : "draft"}`}>
                      {course.isPublished ? "Published" : "Draft"}
                    </span>
                  </td>
                  <td>{course.order ?? 0}</td>
                  <td>
                    <div className="admin-table__actions">
                      <Link to={`/admin/courses/${course._id}/edit`} className="admin-btn admin-btn--outline admin-btn--sm">
                        <Pencil size={14} /> Edit
                      </Link>
                      <button
                        className="admin-btn admin-btn--outline admin-btn--sm"
                        onClick={() => handleDuplicate(course)}
                        disabled={duplicatingId === course._id}
                      >
                        <Copy size={14} /> {duplicatingId === course._id ? "Duplicating…" : "Duplicate"}
                      </button>
                      <button
                        className="admin-btn admin-btn--danger admin-btn--sm"
                        onClick={() => handleDelete(course)}
                        disabled={deletingId === course._id}
                      >
                        <Trash2 size={14} /> {deletingId === course._id ? "Deleting…" : "Delete"}
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}